import { render, staticRenderFns } from "./GerenciaCadastroQhPlanos.vue?vue&type=template&id=3d24d32e"
import script from "./GerenciaCadastroQhPlanos.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroQhPlanos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports